import React from 'react';

export default () => (
    <div className="content">
        <h1>Spørsmål og svar på ofte stilte spørsmål</h1>

        <p><em>Vil bli tilgjengelig etter hvert som det dukker opp spørsmål. Vi antar at det er flere som vil kunne lure på det samme.</em></p>
    </div>
)




// WEBPACK FOOTER //
// ./src/FaqPage/index.js